import { Component, OnInit, ViewChild, HostBinding, ElementRef, NgZone, Input, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { ReportingLineDefinitionEntity } from './reporting-line-definition.entity';
import { ReportingLineDataEntity } from './reporting-line-data.entity';
import { reportingLineDimensionEntity } from './reporting-line-dimension.entity';
import { of } from 'rxjs';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType } from '@gsp-svc/expression';
import { LookupGridComponent } from '@farris/ui-lookup';
import { SysFarrisTreeHelpComponent } from "@gsp-sys/sysmgr-ui";
import { PerformerEntity } from "../../entities/performer.entity";
import { WfReportDefHelpComponent } from "./service/wf-report-def-help.component";
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';
declare var System: any;

@Component({
  selector: 'app-reporting-line',
  templateUrl: './reporting-line.component.html',
  styleUrls: ['./reporting-line.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class ReportingLineComponent implements OnInit {
  @HostBinding('class')
  cls = 'd-flex flex-fill h-100';
  treeFilter = '';
  display: string = 'none';
  typeReadOnly = false;
  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';
  defName = '';

  /**
   * 汇报关系数据
   */
  reportingLineDataEntity: ReportingLineDataEntity = new ReportingLineDataEntity();

  /**
   * 汇报关系定义列表
   */
  reportingLineDefinitionList: ReportingLineDefinitionEntity[] = [];
  reportingLineDefinition: any;

  reportingLineDimension: reportingLineDimensionEntity[] = [];
  @ViewChild(WfReportDefHelpComponent) reportingLineDefHelp: WfReportDefHelpComponent;

  @Input()
  set setReportingLineDataEntity(dataEntity: ReportingLineDataEntity) {
    this.defName = dataEntity.reportingLineDefName;
    this.reportingLineDataEntity = dataEntity;
    const defUrl = '/api/runtime/wf/v1.0/reportingLineDefinitions/' + dataEntity.reportingLineDefId;
    this.http.get(defUrl).subscribe((re: any) => {
      this.reportingLineDefinition = re;
      this.designerUIState.dimensions = [
        { value: 'higherSuperior', text: this.localePipe.transform('component.reportingLine.higherSuperior') }
      ];
      // 兼容历史数据
      if (JSON.parse(this.reportingLineDefinition.dimensions)[0].code !== 'directSuperior') {
        const di = {
          value: 'directSuperior',
          text: this.localePipe.transform('component.reportingLine.directSuperior')
        };
        this.designerUIState.dimensions.push(di);
      }
      for (const dimension of JSON.parse(this.reportingLineDefinition.dimensions)) {
        const di = {
          value: dimension.code,
          text: dimension.name
        };
        this.designerUIState.dimensions.push(di);
      }
    });
    this.users = [dataEntity];
    if (dataEntity.refUserId) {
      this.users[0].performerName = this.variableParticipantName(dataEntity.refUserId);
      this.curReportingRefer = this.reportingReferObjects[1].value;
      this.display = 'block';
    } else if (dataEntity.refEmployeeId) {
      this.users[0].performerName = dataEntity.refEmployeeId;
      this.curReportingRefer = this.reportingReferObjects[2].value;
      this.display = 'block';
    } else {
      this.curReportingRefer = this.reportingReferObjects[0].value;
    }
    if (dataEntity.reportingLineDefId) {
      this.typeReadOnly = true;
    }
  }

  @ViewChild(LookupGridComponent) lookup: LookupGridComponent;
  @ViewChild(SysFarrisTreeHelpComponent) orgHelp: SysFarrisTreeHelpComponent;
  @ViewChild('inputGroup') inputGroup: ElementRef;
  @ViewChild('inputGroup1') inputGroup1: ElementRef;
  showClearButton = false;
  condition: string;
  items: ReportingLineDefinitionEntity[] = [];
  users: PerformerEntity[] = [];
  departments: PerformerEntity[] = [];
  pageIndex = 1;
  pageSize = 20;
  pageList = [10, 20, 30, 50, 100];
  total = 0;

  /**
   * 汇报类型显示列
   */
  columns = [
    { title: this.localePipe.transform('component.reportingLine.code'), field: 'code', width: 100 },
    { title: this.localePipe.transform('component.reportingLine.name'), field: 'name', width: 100 }
  ];

  /**
   *  参与者列表汇报关系显示字段
   */
  reportingReferObjects = [
    { name: this.localePipe.transform('component.reportingLine.dept'), value: 'dept' },
    { name: this.localePipe.transform('component.reportingLine.sysUser'), value: 'sysUser' },
    { name: this.localePipe.transform('component.reportingLine.employee'), value: 'employee' }
  ];
  curReportingRefer = this.reportingReferObjects[0].value;


  constructor(
    private http: HttpService,
    public designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private ngZone: NgZone,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.getReportingLineType();
  }

  ngOnInit() {
  }

  /**
   * 获取汇报关系类型
   */
  getReportingLineType() {
    const url = '/api/runtime/wf/v1.0/reportingLineDefinitions';
    this.http.get(url).subscribe((re: any) => {
      this.reportingLineDefinitionList = re;
      this.items = this.reportingLineDefinitionList.slice(0, this.pageSize);
      this.total = this.reportingLineDefinitionList.length;
    });
  }

  onclear() {
    this.reportingLineDataEntity = new ReportingLineDataEntity();
  }

  // 参照类型改变
  referObjectChange(data: any) {
    if (data === 'dept') {
      this.display = 'none';
      this.curReportingRefer = this.reportingReferObjects[0].value;
      this.reportingLineDataEntity.refUserId = null;
      this.reportingLineDataEntity.refEmployeeId = null;
    } else if (data === 'sysUser') {
      this.display = 'block';
      this.curReportingRefer = this.reportingReferObjects[1].value;
      this.reportingLineDataEntity.refOrgId = null;
      this.reportingLineDataEntity.refOrgName = null;
      this.reportingLineDataEntity.refEmployeeId = null;
    } else { // 员工的情况
      this.display = 'block';
      this.curReportingRefer = this.reportingReferObjects[2].value;
      this.reportingLineDataEntity.refOrgId = null;
      this.reportingLineDataEntity.refOrgName = null;
      this.reportingLineDataEntity.refUserId = null;
    }
    // 参照对象切换时，清空user和department
    this.users = [];
    this.departments = [];
  }

  /**
   * 参照用户改变
   */
  referUserChange(data: any) {
    console.log(data);
  }

  /**
   * 维度改变
   */
  reportingDimensionChange(data: any) {
  }

  /**
   * 组织帮助选完后
   */
  orgSelected(org: any) { // 组织帮助选完后
    this.reportingLineDataEntity.refOrgId = org.id;
    this.reportingLineDataEntity.refOrgName = org.name;
  }

  /**
   * 编辑条件
   */
  editCondition() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Conditional); // 表达式展现模式：默认简易版
    this.expr.addExpressionText(this.reportingLineDataEntity.condition); // this.reportingLineDataEntity.condition
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.reportingLineDataEntity.condition = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  getReportingTypes(value?: string) {
    const start = (this.pageIndex - 1) * this.pageSize;
    const end = start + this.pageSize;
    let items = [];
    if (value) {
      items = this.reportingLineDefinitionList.filter(f => f.name.indexOf(value) > -1 || f.code.indexOf(value) > -1);
    } else {
      items = this.reportingLineDefinitionList;
    }
    this.total = items.length;
    this.items = items.slice(start, end);
    this.lookup.componentRef.instance.loadData({
      total: this.total,
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: this.items
    });
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
      this.inputGroup1.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup1.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }
  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }
  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }

  clear(data: any) {
    this.reportingLineDataEntity.refOrgId = '';
    this.reportingLineDataEntity.refOrgName = '';
  }
  clearUser() {
    this.users = [];
    this.reportingLineDataEntity.refUserId = '';
    this.reportingLineDataEntity.refEmployeeId = '';
  }
  clearOrg() {
    this.departments = [];
    this.reportingLineDataEntity.refOrgId = '';
  }

  selectOrg(data: string) {
    this.showExprHelp(data);
  }

  selectUsers(data: string) {
    this.showExprHelp(data);
  }
  showExprHelp(data: string) {
    // this.expr.clearContext();
    this.expr.setEditPattern(ExprEditMode.Advanced); // 表达式展现模式：默认高级
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    const context = new Array();
    if (this.designerUIState.participantContext.length > 0) {
      for (const variable of this.designerUIState.participantContext) {
        context.push(variable);
      }
    }
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.processVariableContext.length > 0) {
      for (const variable of this.designerUIState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    if (data === 'sysUser') {
      if (this.reportingLineDataEntity.refUserId && this.reportingLineDataEntity.refUserId.length > 0) {
        this.expr.addExpressionText(this.reportingLineDataEntity.refUserId);
      } else {
        this.expr.addExpressionText('');
      }
    } else if (data === 'org') {
      if (this.reportingLineDataEntity.refOrgId && this.reportingLineDataEntity.refOrgId.length > 0) {
        this.expr.addExpressionText(this.reportingLineDataEntity.refOrgId);
      } else {
        this.expr.addExpressionText('');
      }
    } else { // 员工及其他汇报对象类型
      if (this.reportingLineDataEntity.refEmployeeId && this.reportingLineDataEntity.refEmployeeId.length > 0) {
        this.expr.addExpressionText(this.reportingLineDataEntity.refEmployeeId);
      } else {
        this.expr.addExpressionText('');
      }
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      if (data === 'sysUser') {
        const user = new PerformerEntity(expressionInfo, '', 'wf.ReportingLineParticipantExpression'); // wf.UserParticipantExpression
        user.tag = 'expression';
        user.performerName = this.variableParticipantName(expressionInfo);
        this.reportingLineDataEntity.refUserId = user.performerId;
        this.reportingLineDataEntity.tag = user.tag;
        this.reportingLineDataEntity.performerName = user.performerName;
        this.users = [this.reportingLineDataEntity];
      } else if (data === 'org') {
        const dept = new PerformerEntity(expressionInfo, '', 'wf.ReportingLineParticipantExpression');
        dept.tag = 'expression';
        this.reportingLineDataEntity.refOrgName = expressionInfo;
        this.reportingLineDataEntity.refOrgId = expressionInfo;
        this.departments = [this.reportingLineDataEntity];
      } else {
        const employee = new PerformerEntity(expressionInfo, '', 'wf.ReportingLineParticipantExpression');
        employee.performerName = expressionInfo;
        employee.tag = 'expression';
        this.reportingLineDataEntity.refEmployeeId = expressionInfo;
        this.reportingLineDataEntity.performerName = employee.performerName;
        this.users = [this.reportingLineDataEntity];
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  private variableParticipantName(expr: string): string {
    for (const c of this.designerUIState.participantContext) {
      if (expr.indexOf(c.key) > -1) {
        return c.name;
      }
    }
    for (const c of this.designerUIState.processVariableContext) {
      if (expr.indexOf(c.key) > -1) {
        return c.name;
      }
    }
    return this.localePipe.transform('component.reportingLine.businessFields');
  }

  defChanged() {
    System.import('/platform/runtime/wf/web/wf-reporting-data/reportingLineDefHelp.js?v=20231123').then(() => {
      (window as any).gspWfReportingLineDef.ReportingLineDefHelpUtil.getReportingLineHelp().then(data => {
        this.defSelected(data);
      });
    });
  }

  defSelected(data) {
    this.defName = data.name;
    this.reportingLineDataEntity.reportingLineDefId = data.id;
    this.reportingLineDataEntity.reportingLineDefName = data.name;

    this.reportingLineDimension = JSON.parse(data.dimensions);
    this.designerUIState.dimensions = [
      { value: 'higherSuperior', text: this.localePipe.transform('component.reportingLine.higherSuperior') }
    ];
    // 兼容历史数据
    if (this.reportingLineDimension[0].code !== 'directSuperior') {
      const di = {
        value: 'directSuperior',
        text: this.localePipe.transform('component.reportingLine.directSuperior')
      }
      this.designerUIState.dimensions.push(di);
    }
    for (const dimension of this.reportingLineDimension) {
      const di = {
        value: dimension.code,
        text: dimension.name
      };
      this.designerUIState.dimensions.push(di);
    }
    // 定义切换后，默认是参照组织
    this.curReportingRefer = this.reportingReferObjects[0].value;
    // 下边的参照人也得隐藏 2023-5-18
    this.display = 'none';
    this.reportingLineDataEntity.refUserId = null;
    this.reportingLineDataEntity.refEmployeeId = null;
    return of(true);
  }

  getPerformers() {
    this.reportingLineDataEntity.type = 'wf.ReportingLineParticipantExpression';
    this.reportingLineDataEntity.reportingReferObject = this.curReportingRefer;
    return this.reportingLineDataEntity;
  }
}
